import React from 'react';
import { Box, SxProps, IconButton, useTheme } from '@mui/material';
import { fixedSizes } from 'shared/hooks/useGetSpacing';
import { useBooleanScreens } from 'shared/hooks/useBooleanScreens';
import LimitedTypography from 'shared/lib/components/text/limitedTypography';
import IconEdit from 'shared/icons/iconEdit';
import { borderRadiusValues } from 'shared/lib/utils/uiConstants';

export default function SectionWidgetHeader({
  sx,
  image,
  sectionName,
  onStartEdit,
  isHover,
}: {
  sx?: SxProps;
  image?: string;
  sectionName?: string;
  onStartEdit?: () => void;
  isHover: boolean;
}) {
  const { isLessLaptop } = useBooleanScreens();
  const theme = useTheme();

  return (
    <Box
      sx={{
        wordBreak: 'break-word',
        display: 'flex',
        alignItems: 'center',
        gap: isLessLaptop ? 2 : 4,
        textAlign: 'left',
        ...sx,
      }}
    >
      {image && (
        <Box
          sx={{
            width: fixedSizes.section.sectionIcon,
            height: fixedSizes.section.sectionIcon,
            minWidth: fixedSizes.section.sectionIcon,
            minHeight: fixedSizes.section.sectionIcon,
          }}
        >
          <img
            src={image}
            alt=""
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          ></img>
        </Box>
      )}
      <LimitedTypography
        color={theme.palette.primary.main}
        sx={{}}
        variant={isLessLaptop ? 'f16bfixed' : 'f24bfixed'}
        clamp={2}
      >
        {sectionName}
      </LimitedTypography>
      {onStartEdit && !isLessLaptop && (
        <IconButton
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onStartEdit();
          }}
          sx={{
            'marginLeft': 'auto',
            'marginRight': '10px',
            'backgroundColor': theme.palette.neutral.tonal,
            'borderRadius': borderRadiusValues.small,
            'zIndex': 2,
            'width': '40px',
            'height': '40px',
            'opacity': isHover || isLessLaptop ? 1 : 0,
            '&:hover': {
              bgcolor: theme.palette.neutral.tonalHover,
            },
          }}
          data-testid={'section-button-edit'}
        >
          <IconEdit
            isAutoscallable={false}
            extColor={theme.palette.text.primary}
          ></IconEdit>
        </IconButton>
      )}
    </Box>
  );
}
